const PasswordResetError = {
  INVALID_TOKEN: 'INVALID_TOKEN',
  ALREADY_ACTIVATED: 'ALREADY_ACTIVATED',
  EXPIRED: 'EXPIRED',
};
export default PasswordResetError;
